import { useEffect, useState } from 'react';
import { IntersectionOptions, useInView } from 'react-intersection-observer';

type TriggerWhenVisibleProps = {
    children: (isTriggered: boolean) => React.ReactNode;
    triggerDelay?: number;
    testId?: string;
    rootMargin?: string;
};

export const TriggerWhenVisible = ({
    children,
    triggerDelay = 0,
    testId,
    rootMargin
}: TriggerWhenVisibleProps) => {
    const options: IntersectionOptions | undefined = rootMargin
        ? { rootMargin }
        : undefined;
    const { ref, inView } = useInView(options);
    const [isTriggered, setIsTriggered] = useState(false);

    useEffect(() => {
        if (inView) {
            const timeoutId = setTimeout(() => {
                setIsTriggered(true);
            }, triggerDelay);
            return () => {
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [inView, triggerDelay]);

    return (
        <div
            className="trigger-when-visible"
            data-testid={testId || 'trigger-when-visible'}
            ref={ref}
        >
            {children(isTriggered)}
        </div>
    );
};
